import { ModelFactory } from '@shared/factories/model.factory';
import { ProfileType } from '@generated/graphql';
import { Profile } from '@modules/profile/models/profile.model';

export class ProfileFactory extends ModelFactory<ProfileType, Profile> {
  create (state: ProfileType): Profile {
    return new Profile(state);
  }
}

export const profileFactory = new ProfileFactory();
